import { render, staticRenderFns } from "./list-links-icon.vue?vue&type=template&id=2b99201b&scoped=true&"
import script from "./list-links-icon.vue?vue&type=script&lang=js&"
export * from "./list-links-icon.vue?vue&type=script&lang=js&"
import style0 from "./list-links-icon.vue?vue&type=style&index=0&id=2b99201b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99201b",
  null
  
)

export default component.exports